import { createSelector } from 'reselect';
import { showPdpFulfillmentSelectorSelector } from 'selectors/testTarget/offers/showPdpFulfillmentSelector/showPdpFulfillmentSelectorSelector';

const showSelector = createSelector(showPdpFulfillmentSelectorSelector, showPdpFulfillmentSelector => !!showPdpFulfillmentSelector.show);

export { showSelector };
